import React from 'react';
import GavelIcon from '@mui/icons-material/Gavel';
import WorkIcon from '@mui/icons-material/Work';
import SecurityIcon from '@mui/icons-material/Security';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import ParkIcon from '@mui/icons-material/Park';
import EventIcon from '@mui/icons-material/Event';
import BusinessIcon from '@mui/icons-material/Business';
import DescriptionIcon from '@mui/icons-material/Description';
import FolderIcon from '@mui/icons-material/Folder';

export interface AreaStyle {
  label: string;
  color: string;
  icon: React.ReactElement;
}

export const AREA_STYLES: Record<string, AreaStyle> = {
  civel:           { label: 'Cível',           color: '#1a365d', icon: <GavelIcon /> },
  trabalhista:     { label: 'Trabalhista',     color: '#744210', icon: <WorkIcon /> },
  criminal:        { label: 'Criminal/Penal',  color: '#1d4ed8', icon: <SecurityIcon /> },
  previdenciario:  { label: 'Previdenciário',  color: '#059669', icon: <HealthAndSafetyIcon /> },
  transito:        { label: 'Trânsito',        color: '#ca8a04', icon: <DirectionsCarIcon /> },
  magistratura:    { label: 'Magistratura',    color: '#0891b2', icon: <AccountBalanceIcon /> },
  familia:         { label: 'Família',         color: '#db2777', icon: <FamilyRestroomIcon /> },
  ambiental:       { label: 'Ambiental',       color: '#16a34a', icon: <ParkIcon /> },
  empresarial:     { label: 'Empresarial',     color: '#475569', icon: <BusinessIcon /> },
  administrativo:  { label: 'Administrativo',  color: '#7c3aed', icon: <AccountBalanceIcon /> },
  tributario:      { label: 'Tributário',      color: '#0d9488', icon: <AccountBalanceIcon /> },
  recesso:         { label: 'Recesso',         color: '#ea580c', icon: <EventIcon /> },
  geral:           { label: 'Geral',           color: '#6b7280', icon: <FolderIcon /> },
};

export function getAreaStyle(area: string): AreaStyle {
  return AREA_STYLES[area] || { label: area, color: '#6b7280', icon: <DescriptionIcon /> };
}

export function getAreaIcon(area: string, fontSize: number = 20): React.ReactElement {
  const style = getAreaStyle(area);
  return React.cloneElement(style.icon, { sx: { fontSize, color: style.color } });
}
